import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useCheckoutHref } from '../../hooks/useCheckoutHref';
import { OFFER_ANCHOR } from '../../data/site';
import { easeOutStrong } from '../../utils/format';
import { trackInitiateCheckout } from '../../utils/metaPixel';
const HIDE_ZONES = ['hero', 'look-inside', 'offer-details', 'final-cta'];
function isInView(el: HTMLElement | null): boolean {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

/** Mobile-only bar: leads to the offer before it, to checkout after it. Hidden near the offer, previews and final purchase. */
export function StickyBar() {
  const checkoutHref = useCheckoutHref();
  const [state, setState] = useState({
    visible: false,
    pastOffer: false
  });
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const offer = document.getElementById('offer-details');
      const footer = document.querySelector('footer');
      const hidden = HIDE_ZONES.some(id => isInView(document.getElementById(id))) || isInView(footer);
      const pastOffer = offer ? offer.getBoundingClientRect().bottom < 0 : false;
      setState(prev => prev.visible === !hidden && prev.pastOffer === pastOffer ? prev : {
        visible: !hidden,
        pastOffer
      });
    };
    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
  return <AnimatePresence data-id="element-182" data-mp="1w6svbkkmni6w">
      {state.visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: easeOutStrong
    }} className="fixed inset-x-0 bottom-0 z-40 border-t-2 border-gold bg-mint md:hidden" style={{
      paddingBottom: 'env(safe-area-inset-bottom)'
    }} data-id="element-183" data-mp="1r913srnw9y38">
          <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-184" data-mp="3bsecanr2diiq">
            <div className="min-w-0 text-ink" data-id="element-185" data-mp="3gpd5n42wllfv">
              <p className="font-display text-[24px] font-bold leading-none" data-id="element-186" data-mp="3go21v49gkdor">
                $27 <span className="text-sm text-body" data-id="element-187" data-mp="8aw42f7dq9hs">USD</span>
              </p>
              <p className="mt-1 truncate text-[13px] text-body" data-id="element-188" data-mp="d8eium82vixp">Full year planned + 5 bonuses</p>
            </div>
            <a href={state.pastOffer ? checkoutHref : OFFER_ANCHOR} onClick={state.pastOffer ? trackInitiateCheckout : undefined} className="inline-flex h-12 shrink-0 items-center rounded-[14px] bg-go px-5 font-display text-[20px] font-bold uppercase text-ink shadow-[0_4px_0_#8A3A0C] transition-colors duration-150 hover:bg-go-hover" data-id="element-189" data-mp="3uh1g72xi81uq">
              {state.pastOffer ? 'Get the pack' : 'See the offer'}
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}